Librarian.QuickSearch = new Class({
    Extends: Librarian.Request.JSON,
    Binds: ["loadComplete", "onBeforeSearch", "addTerm", "setSearchKeywords", "setSearchSlideText", "addResults", "search"],

    options: {
        method: "POST",
        loadComplete: null, /*(json, text)*/
        onFailure: Librarian.Utils.onFailure,
        outFormat: "dgrid",
        catType: Librarian.catType.file,
        cancelAll: false
    },

    // Data structure to send to the server
    defaultSearchOptions: {
        terms: {
            includeKeywords: false,
            includeSlideText: false,
            includeDescription: false,
            conjunction: null,
            operator: null,
            items: []
        },
        contents: {
            contactId: -1,
            contactType: 0,
            items: []
        },
        resultsOptions: {
            startRow: 1,
            maxRows: 24,
            viewName: null,
            outputType: null,
            orderByColumns: [{
                name: "fRank",
                order: "Desc"
            }]
        }
    },

    searchOptions: null,

    initialize: function(options) {
        if ((typeof options == "undefined") || (options == null))
            options = {};

        this.setOptions(options);

        this.options.onSuccess = this.loadComplete;
        this.options.onException = options.onException;

        this.searchOptions = Object.clone(this.defaultSearchOptions);

        this.parent(this.options);
    },

    destroy: function() {
        this.cancel();
        this.clean();
        this.searchOptions = Object.clone(this.defaultSearchOptions);
    },

    clean: function() {
        this.response = null;

        this.xhr = null;

        this.xhr = new Browser.Request();
    },

    loadComplete: function(json, text) {
        if (typeof this.options.loadComplete == "function")
            this.options.loadComplete(json, text, this.options.catType, this.options.cancelAll);
    },

    onBeforeSearch: function() {
        // Should be overwritten on a per-library basis
        return true;
    },

    search: function() {
        if (!this.onBeforeSearch())
            return;

        var data = JSON.stringify(this.searchOptions);
        if (typeof Base64 != "undefined")
            data = Base64.encode(data);

        this.options.url = Librarian.path.getSearchUrl("qs") + "&out=" + this.options.outFormat + "&in=cjson";
        this.options.data = data;
        this.send();
    },

    addTerm: function(term, conjunction, operator) {
        if ((typeof conjunction == "undefined") || (conjunction == null))
            conjunction = Librarian.search.defaultConjunction;

        this.searchOptions.terms.conjunction = conjunction;

        if ((typeof operator != "undefined") && (operator != null))
            this.searchOptions.terms.operator = operator;

        if (Librarian.search.splitQuicksearchTerms) {
            term = term.split(' ');
            for (var i = term.length; i--;) {
                term[i] = term[i].trim();
                if (term[i].length > 0)
                    this.searchOptions.terms.items.push(term[i]);
            }
        }
        else
            this.searchOptions.terms.items.push(term);

        return true;
    },

    addResults: function(startRow, maxRows, outputType, orderBy, order, viewName/*, returnType*/) {
        if ((typeof startRow == "number") && (startRow > 0))
            this.searchOptions.resultsOptions.startRow = startRow;
        if ((typeof maxRows == "number") && (maxRows > 0) && !Librarian.listView.enabled)
            this.searchOptions.resultsOptions.maxRows = maxRows;
        if (Librarian.listView.enabled)
            this.searchOptions.resultsOptions.maxRows = null;
        if ((typeof viewName == "string") && (viewName.length > 0))
            this.searchOptions.resultsOptions.viewName = viewName;

        if ((typeof outputType != "undefined") && (outputType != null)) {
            this.searchOptions.resultsOptions.outputType = outputType;

            if (outputType == Librarian.Search.outputTypes.GROUPS)
                this.options.catType = Librarian.catType.globalFavorite;
            else
                this.options.catType = Librarian.catType.file;
        }

        if (typeof orderBy == "string") {
            var orderByObj = {
                name: orderBy
            };
            if (typeof order == "string")
                orderByObj.order = order.toUpperCase();

            this.searchOptions.resultsOptions.orderByColumns.push(orderByObj);
        }

        return true;
    },

    setSearchKeywords: function(includeKeywords) {
        this.searchOptions.terms.includeKeywords = !!includeKeywords;
        return true;
    },

    setSearchSlideText: function (includeSlideText) {
        this.searchOptions.terms.includeSlideText = !!includeSlideText;
        return true;
    },

    setSearchDescriptions: function(includeDescription) {
        this.searchOptions.terms.includeDescription = !!includeDescription;
        return true;
    },

    addContent: function(eventId, contactId, contactType/*, conjunction*/) {
        this.searchOptions.contents.contactId = contactId;
        this.searchOptions.contents.contactType = contactType;
        this.searchOptions.contents.items.push({
            eventId: eventId
        });

        return true;
    },

    getOutputType: function() {
        return this.searchOptions.resultsOptions.outputType;
    },

    getCurrentPage: function() {
        if (!this.searchOptions)
            return null;

        var startRow = this.searchOptions.resultsOptions.startRow;
        if (startRow == null)
            startRow = 1;

        var maxRows = this.searchOptions.resultsOptions.maxRows;
        if (maxRows == null)
            maxRows = Librarian.search.maxResults;

        return Math.ceil(startRow / maxRows);
    },

    // Compatibility with Advanced Search
    hasSearchNode: function(/*node*/) {
        return true;
    },

    addCategory: function() {
        // Not implemented
        return true;
    },

    deleteEmptyFilters: function() {
        // Not implemented
    },

    setSearchSource: function() {
        // Not implemented
    },

    toAdvancedSearch: function() {
        // Translate search properties to advanced search
        var search = new Librarian.Search();

        search.options.loadComplete = this.options.loadComplete;

        // Add Search Terms
        var terms = this.searchOptions.terms.items,
            conjunction = this.searchOptions.terms.conjunction,
            operator = this.searchOptions.terms.operator,
            outputType = this.searchOptions.resultsOptions.outputType,
            typeName, itemTypeName;

        switch (outputType) {
            case Librarian.Search.outputTypes.GROUPS:
                itemTypeName = typeName = "Group";
                break;
            case Librarian.Search.outputTypes.SLIDES:
                typeName = "Slide";
                itemTypeName = "File";
                break;
            default:
                itemTypeName = typeName = "File";
        }

        // Re-join the search terms if they were originally split
        if (Librarian.search.splitQuicksearchTerms)
            terms = [Librarian.search.splitQuicksearchTerms.join(' ')];

        // Add each term based on the settings this quick search has set
        for (var i = 0, length = terms.length; i < length; i++) {
            var originalTerm = terms[i],
                term = terms[i];
            if ((conjunction == "AND") || (conjunction == "OR"))
                term = Librarian.Search.prepValue(term, null, conjunction);

            if (this.searchOptions.terms.includeKeywords)
                search["add" + typeName + "Keyword"](term, conjunction, operator, null, "OR");

            if (this.searchOptions.terms.includeSlideText)
                search.addTextTerm(term, conjunction, operator, null, "OR");

            // Search the file name using the original term since it isn't Full-Text
            search["add" + itemTypeName + "Term"](originalTerm, conjunction, operator, 1, "OR");

            // If we're searching the description, use the full-text prepared term for that
            if (this.searchOptions.terms.includeDescription) {
                var flags = 0;
                if (outputType == Librarian.Search.outputTypes.GROUPS)
                    flags &= Librarian.Search.Container.getFlagValue(Librarian.Search.Container.groupTermFlags, "description");
                else if (outputType == Librarian.Search.outputTypes.FILES)
                    flags &= Librarian.Search.Container.getFlagValue(Librarian.Search.Container.fileTermFlags, "description");

                if (flags > 0)
                    search["add" + itemTypeName + "Term"](term, conjunction, operator, flags, "OR");
            }
        }

        // Add search content for event-based filtering
        var contents = this.searchOptions.contents.items,
            contactId = this.searchOptions.contents.contactId,
            contactType = this.searchOptions.contents.contactType;
        for (var i = 0, length = contents.length; i < length; i++)
            search.addContents(contents[i].eventId, contactId, contactType);

        // Add result options
        var resultOptions = this.searchOptions.resultsOptions;
        search.addResults(resultOptions.startRow, resultOptions.maxRows, outputType, null, null, resultOptions.viewName);
        if (resultOptions.orderByColumns && (resultOptions.orderByColumns.length) > 0) {
            for (var i = 0, length = resultOptions.orderByColumns.length; i < length; i++)
                search.addResults(null, null, null, resultOptions.orderByColumns[i].name, resultOptions.orderByColumns[i].order);
        }

        // Clear up anything extra
        search.deleteEmptyFilters();

        return search;
    }
});